export const interval = {
    namespaced: true,
    state: {
        intervals: []
    },
    actions: {
        setInterval({ commit }, payload) {
            commit('setInterval', payload);
        },
        getInterval: (state) => (name) => {
            return state.intervals.find(interval => interval.name === name);
        },
        clearInterval({ commit }, name) {
            commit('clearInterval', name);
        }
    },
    mutations: {
        setInterval(state, { name, id }) {
            const interval = state.intervals.find(interval => interval.name === name);
            if (interval) {
                interval.id = id;
            } else {
                state.intervals.push({ name, id });
            }
        },
        clearInterval(state, name) {
            console.log('clearInterval', name);
            const interval = state.intervals.find(interval => interval.name === name);
            if (interval && interval.id) {
                clearInterval(interval.id);
            }
            state.intervals = state.intervals.filter(interval => interval.name !== name);
        }
    },
}


// // Example usage

// Vue.use(Vuex);

// const store = new Vuex.Store({
//     modules: {
//         interval
//     }
// });

// store.dispatch('interval/setInterval', { name: 'interval1', id: 1 });
// console.log(store.getters['interval/getIntervalByName']('interval1')); // { name: 'interval1', id: 1 }

// store.dispatch('interval/clearInterval', 'interval1');
// console.log(store.getters['interval/getIntervalByName']('interval1')); // undefined
